<template>
  <div class="d-flex" :class="smAndDown ? 'flex-column' : ''">
    <v-col sm="12" md="7" class="d-flex flex-wrap justify-space-between ga-5">
      <!-- devices button -->
      <v-btn
        v-if="hasOrderDevicePermission"
        to="/request-new-device"
        size="large"
        append-icon="mdi-arrow-right"
        color="purple-8 rounded-xxl d-flex flex-column align-center"
        :height="smAndDown ? 80 : 211"
        width="45%"
      >
        {{ t("app.landing.orderDevices") }}
      </v-btn>
      <!-- transactions button -->
      <v-btn
        to="/transactions"
        size="large"
        append-icon="mdi-arrow-right"
        icon-size="100"
        color="purple-8 rounded-xxl d-flex flex-column align-center"
        :height="smAndDown ? 80 : 211"
        width="45%"
      >
        {{ t("app.landing.viewTransactions") }}
      </v-btn>
    </v-col>
    <v-col v-if="shouldDisplayTaskSummary" sm="12" md="5">
      <OnboardingTaskSummary
        :onboarding-actions="merchantsStore.currentMerchant?.onboardingActions"
        @onboarding-status-click="handleOnboardingTaskClick"
      />
    </v-col>
    <v-col v-else sm="12" md="5">
      <CapitalOverview />
    </v-col>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useDisplay } from "vuetify";
import CapitalOverview from "@/components/Capital/CapitalOverview.vue";
import OnboardingTaskSummary from "@/components/Onboarding/OnboardingTasksSummary.vue";
import { useYetipayApi } from "@/composables/useYetipayApi";
import { useApplicationStore } from "@/store/application";
import { Permission, useAuthorizationStore } from "@/store/authorization";
import { useMerchantsStore } from "@/store/merchants";

const { t } = useI18n();
const { smAndDown } = useDisplay();

const applicationStore = useApplicationStore();
const merchantsStore = useMerchantsStore();
const authorizationStore = useAuthorizationStore();

const { api } = useYetipayApi();

const hasOrderDevicePermission = computed(() =>
  authorizationStore.hasCompanyScoped(Permission.Device_OrderDevice),
);
const shouldDisplayTaskSummary = computed(
  () =>
    authorizationStore.hasCompanyScoped(Permission.Device_OrderDevice) &&
    merchantsStore.currentMerchant?.kycOnboardingStatus !== "verified",
);

const handleOnboardingTaskClick = async (taskName: string) => {
  console.log(taskName);
  if (taskName === "contract") {
    const dealUrl = merchantsStore.currentMerchant?.dealSignedUrl;
    if (!dealUrl) {
      applicationStore.notifyUser({ message: t("app.landing.contractError"), type: "error" });
      return;
    }
    window.open(dealUrl, "_self");
  } else {
    try {
      await merchantsStore.initialize(false);
      const { data: result } = await api.createVerificationLink(
        merchantsStore.currentMerchant!.merchantId,
        {
          isOnboardingV2: true,
        },
      );
      window.open(result.data, "_self");
    } catch (error) {
      console.error(error);
      applicationStore.notifyUser({ message: t("app.landing.onboardingError"), type: "error" });
    }
  }
};
</script>

<style scoped>
.v-btn :deep(.v-btn__content) {
  white-space: normal;
  word-wrap: break-word;
}
</style>
